import React, { useEffect, useState } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import {
  Checkbox,
  FormControl,
  Grid,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  Select,
  Tooltip,
} from '@material-ui/core';
import { setSpecificSpecialEventData } from '../../../redux/actions/newOperationHoursActions';
import { formatTime } from '../../../utils/utils';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    root: {
      flexGrow: 1,
      borderBottom: '1px solid',
      borderBottomColor: '#bdbdbd',
      marginTop: 5,
    },
    demo: {
      backgroundColor: '#f5f5f5',
    },
  }),
);

// eslint-disable-next-line import/no-anonymous-default-export
export default function RowCatering({ disableAll, restaurantId = '' }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const dispatch: any = useDispatch();

  const {
    cateringTimeOpenMode,
    cateringTimeCloseMode,
    cateringTimeOpen,
    cateringTimeClose,
    availableTimes,
    cateringIsClosed,
    cateringIsClosedMode,
    is12HFormat,
  } = useSelector((state: RootStateOrAny) => state.NewOperationHoursReducer);

  const restaurantServices = useSelector(
    (state: RootStateOrAny) => state.ServicesReducer.entities,
  );

  const cateringService = restaurantServices.find(
    elem => elem.code === 'catering',
  );
  const [selectOpenSelectedIndex, setSelectOpenSelectedIndex] = useState(0);

  const disabledSelects = disableAll || cateringIsClosed === 'Y';

  const onChangeSelectOpen = event => {
    const select = event.target as HTMLSelectElement;
    if (cateringTimeOpen !== select.value) {
      dispatch(
        setSpecificSpecialEventData({
          cateringTimeOpen: select.value,
        }),
      );
    }
  };

  const onChangeSelectClose = event => {
    const select = event.target as HTMLSelectElement;
    if (cateringTimeClose !== select.value) {
      dispatch(
        setSpecificSpecialEventData({
          cateringTimeClose: select.value,
        }),
      );
    }
  };

  useEffect(() => {
    const index = availableTimes.findIndex(elem => elem === cateringTimeOpen);
    setSelectOpenSelectedIndex(index);
  }, [cateringTimeOpen]);

  const getValueSelectOpen = () => {
    if (cateringIsClosed === 'Y') {
      return '';
    } else {
      return cateringTimeOpen ? cateringTimeOpen : '';
    }
  };

  const getValueSelectClose = () => {
    if (cateringIsClosed === 'Y') {
      return '';
    } else {
      return cateringTimeClose ? cateringTimeClose : '';
    }
  };

  const onChangeCheckboxIsClosed = e => {
    const checked = e.target.checked;

    const newState: any = {};

    if (checked) {
      newState.cateringIsClosed = 'Y';

      if (cateringIsClosed === 'Y' && hasCloseCatering()) {
        newState.closeToAll = true;
      }
    } else {
      newState.cateringIsClosed = 'N';
      newState.closeToAll = false;
    }

    dispatch(setSpecificSpecialEventData(newState));
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={0}>
        <Grid item xs={4} md={4}>
          <div className={classes.demo}>
            <List>
              <ListItem>
                <ListItemText
                  primary={t('operationHours.cateringTime')}
                  primaryTypographyProps={{ display: 'inline' }}
                  secondary={!restaurantId ? <sup>++</sup> : ''}
                  secondaryTypographyProps={
                    !restaurantId
                      ? {
                          display: 'inline',
                          style: { fontSize: '12px', fontStyle: 'italic' },
                        }
                      : undefined
                  }
                />
              </ListItem>
            </List>
          </div>
        </Grid>
        <Grid item xs={1} md={1}>
          <Checkbox style={{ marginTop: 10, visibility: 'hidden' }} />
        </Grid>
        <Grid item xs={1} md={1}>
          <Checkbox
            style={{ marginTop: 10 }}
            disabled={disableAll || !cateringIsClosedMode?.includes('write')}
            checked={cateringIsClosed === 'Y'}
            onChange={onChangeCheckboxIsClosed}
          />
        </Grid>
        <Grid item xs={3} md={3}>
          {cateringTimeOpenMode.includes('read') ? (
            <Tooltip title={''}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel htmlFor="outlined-time-native-simple">
                  {t('operationHours.start')}
                </InputLabel>
                <Select
                  style={
                    disabledSelects || !cateringTimeOpenMode.includes('write')
                      ? { pointerEvents: 'none', color: 'grey' }
                      : undefined
                  }
                  native
                  value={getValueSelectOpen()}
                  label={t('operationHours.start')}
                  inputProps={{
                    name: 'availableTimes',
                    id: 'outlined-time-native-simple',
                  }}
                  onChange={onChangeSelectOpen}
                  disabled={
                    disabledSelects || !cateringTimeOpenMode.includes('write')
                  }
                >
                  {[...availableTimes, getValueSelectOpen()]?.map(
                    (elem, index) => (
                      <option key={index} value={elem}>
                        {formatTime(elem, is12HFormat)}
                      </option>
                    ),
                  )}
                </Select>
              </FormControl>
            </Tooltip>
          ) : null}
        </Grid>
        <Grid item xs={3} md={3}>
          {cateringTimeCloseMode.includes('read') ? (
            <Tooltip title={''}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel htmlFor="outlined-time-native-simple">
                  {t('operationHours.close')}
                </InputLabel>
                <Select
                  style={
                    disabledSelects || !cateringTimeCloseMode.includes('write')
                      ? { pointerEvents: 'none', color: 'grey' }
                      : undefined
                  }
                  native
                  value={getValueSelectClose()}
                  label={t('operationHours.close')}
                  inputProps={{
                    name: 'availableTimes',
                    id: 'outlined-time-native-simple',
                  }}
                  onChange={onChangeSelectClose}
                  disabled={
                    disabledSelects || !cateringTimeCloseMode.includes('write')
                  }
                >
                  {[...availableTimes, getValueSelectClose()]
                    ?.filter(
                      (elem, index) =>
                        index > selectOpenSelectedIndex || index === 0,
                    )
                    .map((elem, index) => (
                      <option value={elem}>
                        {formatTime(elem, is12HFormat)}
                      </option>
                    ))}
                </Select>
              </FormControl>
            </Tooltip>
          ) : null}
        </Grid>
      </Grid>
    </div>
  );
  function isCateringClosed() {
    return cateringIsClosed === 'Y';
  }

  function hasCatering() {
    return cateringService?.value;
  }

  function hasCloseCatering() {
    return !hasCatering() || isCateringClosed();
  }
}

RowCatering.displayName = 'RowCatering';
